import { Skeleton } from "@solomon-labs/design/components/ui";
import React from "react";

import { FieldRow } from "./FieldRow";

interface FeeFooterProps {
    priceImpact?: string;
    fee?: string;
    networkCost?: string;
    /** When true, each value is replaced with a pulsing skeleton placeholder
     *  to indicate a quote fetch is in flight. */
    loading?: boolean;
    /** Ref for height measurement */
    feeRef?:
        | React.RefObject<HTMLDivElement | null>
        | ((node: HTMLDivElement | null) => void);
    /** Inline style (for fade transitions) */
    style?: React.CSSProperties;
}

const valueSkeleton = <Skeleton inline className="h-3.5 w-12" />;

/**
 * Three-row fee display: Price Impact, Fee, Network Cost.
 * Used as the footer in swap widget shells.
 *
 * @version 1.1.0
 */
export function FeeFooter({
    priceImpact = "-",
    fee = "-",
    networkCost = "-",
    loading = false,
    feeRef,
    style
}: FeeFooterProps): React.ReactElement {
    return (
        <div ref={feeRef} className="flex flex-col md:gap-2" style={style}>
            <FieldRow
                label="Price Impact"
                value={loading ? valueSkeleton : priceImpact}
            />
            <FieldRow label="Fee" value={loading ? valueSkeleton : fee} />
            <FieldRow
                label="Network Cost"
                value={loading ? valueSkeleton : networkCost}
            />
        </div>
    );
}
